import _ from "lodash";
import { Module } from "vuex";
import { I18nTranslationsState } from "./types";
import { RootState } from "../../types";

import { getters, getterNames } from "./getters";
import { actions, actionNames } from "./actions";
import { mutations, mutationNames } from "./mutations";

const state = new I18nTranslationsState();

const namespaced: boolean = true;
const modul: Module<I18nTranslationsState, RootState> = {
  namespaced,
  getters,
  actions,
  mutations,
  state,
};

export const api = {
  namespace: "i18N", // UpperCase N required due to camelCase function.
  mutations: mutationNames,
  getters: getterNames,
  actions: actionNames,
};
export default modul;
